// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25fQf","content":"styles_content__3TBN4","checkbox":"styles_checkbox__3xP0A","checkboxLabel":"styles_checkboxLabel__gy8gz"};